import {
  AGENCY,
  BLOG,
  BLUEPRINT,
  COMPANY,
  CTO,
  EXPERTISE,
  FAQ,
  PRIVACY_POLICY,
  WORK,
} from 'Constants/Paths'

enum FooterNavGroupId {
  Main = 'main',
  Services = 'services',
  Legal = 'legal',
}

enum FooterNavLinkId {
  Expertise = 'expertise',
  Work = 'work',
  Company = 'company',
  Blog = 'blog',
  Agency = 'agency',
  Contact = 'contact',
  FAQ = 'faq',
  Blueprint = 'blueprint',
  CTO = 'cto',
  PrivacyPolicy = 'privacyPolicy',
}

export const FOOTER_NAV_LINKS = [
  {
    id: FooterNavGroupId.Main,
    caption: 'Main',
    items: [
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.Expertise,
        caption: 'Expertise',
        link: EXPERTISE,
      },
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.Work,
        caption: 'Work',
        link: WORK,
      },
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.Company,
        caption: 'Company',
        link: COMPANY,
      },
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.Blog,
        caption: 'Blog',
        link: BLOG,
      },
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.Agency,
        caption: 'Agency',
        link: AGENCY,
      },
    ],
  },
  {
    id: FooterNavGroupId.Services,
    caption: 'Services',
    items: [
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.FAQ,
        caption: 'FAQ',
        link: FAQ,
      },
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.Blueprint,
        caption: 'Blueprint',
        link: BLUEPRINT,
      },
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.CTO,
        caption: 'CTO',
        link: CTO,
      },
    ],
  },
  {
    id: FooterNavGroupId.Legal,
    caption: 'Legal',
    items: [
      {
        id: FooterNavGroupId.Main + FooterNavLinkId.PrivacyPolicy,
        caption: 'Privacy Policy',
        link: PRIVACY_POLICY,
      },
    ],
  },
]
